import classNames from 'classnames'
import React from 'react'
import { ValueLocked } from 'src/components/framework/icons/value-locked'
import { ScoreHeader } from 'src/components/page/ratios/score-header'

import * as styles from './analyst-consensus.module.scss'

export const AnalystConsensus: React.FC = () => {
  const scale = ['Strong Sell', 'Sell', 'Hold', 'Buy', 'Strong Buy']
  return (
    <>
      <ScoreHeader title={'Analyst Consensus'} />
      <div
        className={classNames(
          styles.analystConsensusGraph__bar,
          'stk-space-out-t-2',
        )}
      >
        <span className={styles.analystConsensusGraph__icon}>
          <ValueLocked />
        </span>
      </div>
      <div
        className={classNames(
          styles.analystConsensusGraph__scale,
          'stk-text-small',
        )}
      >
        {scale.map((rating, index) => (
          <span key={index}>{rating}</span>
        ))}
      </div>
    </>
  )
}
